import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Box, CircularProgress, IconButton, Modal, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, styled, useMediaQuery, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useOrders } from "../apis/get-orders";
import { useSettingContext } from "context/SettingContext";
import { useGlobalContext } from "context/GlobalContext";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import { ReactComponent as ImageIcon } from "assets/setting/image.svg";
import { ReactComponent as ColorDiamond } from "../../../../assets/orderClient/color_diamond.svg";
import { ReactComponent as ColorGold } from "../../../../assets/orderClient/color_gold.svg";
import { ReactComponent as ColorRings } from "../../../../assets/orderClient/color_rings.svg";
import { ReactComponent as Email } from "../../../../assets/orderClient/email.svg";
import { ReactComponent as Whatsapp } from "../../../../assets/orderClient/whatsapp.svg";
import { ReactComponent as Unarchive } from "../../../../assets/orderClient/unarchive_small.svg";
import { ReactComponent as Archive } from "../../../../assets/orderClient/archive.svg";
import { ReactComponent as Sync } from "../../../../assets/orderClient/SyncIcon.svg";
import { ReactComponent as SyncError } from "../../../../assets/orderClient/SyncIconError.svg";

import { ReactComponent as Pdf } from "../../../../assets/orderClient/pdf.svg";
import { ReactComponent as Details } from "../../../../assets/orderClient/details.svg";
import { ReactComponent as ErrorDetails } from "../../../../assets/orderClient/errorDetails.svg";
import { ReactComponent as Eye } from "../../../../assets/icons/CatalogueCard/eye.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/Calender.svg";
import { ReactComponent as GreenCalendar } from "../../../../assets/orderClient/green_calendar.svg";
import DetailModal from "./DetailModal";
import DatePickerComp from "./react-DatePicker/DatePickerComp";
import ActionModal from "./actionModal/ActionModal";
import { formatDateAndTime } from "utils/formatDateAndTime";
import apiClient from "lib/api-client";
import { capitalEachLetter } from "utils/capitalEachLetter";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { toast } from "react-toastify";
import config from "configs/config";
import OrdersFileModal from "./OrdersFileModal";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { useSyncOrdertoGati } from "../apis/sync-order";

const StyledTableHeaderCell = styled(TableCell)(({ }) => ({
  fontFamily: "Poppins !important",
  position: "sticky",
  top: 0,
  padding: "10px",
  // paddingLeft: "15px",
  // paddingRight: "15px",
  border: "none",
  zIndex: 1,
  // "&:first-child": {
  //   borderTopLeftRadius: "5px",
  //   borderBottomLeftRadius: "5px",
  // },
  // "&:last-child": {
  //   borderTopRightRadius: "5px",
  //   borderBottomRightRadius: "5px",
  // },
}));

const StyledTableBodyCell = styled(TableCell)(({ color }) => ({
  fontFamily: "Karla !important",
  padding: "10px",
  paddingLeft: "5px",
  paddingRight: "5px",
  border: "none",
  color: `${color} !important`,
  "&:first-child": {},
  "&:last-child": {},
}));

const StyledTableRow = styled(TableRow)(({ }) => ({
  "& td": {
    // padding: "10px",
    // paddingTop: "0px",
  },
  "&:first-of-type td": {
    // padding: "10px",
    // paddingTop: "15px",
  },
}));

const commonColumns = [
  { key: "srno", header: "Sr No" },
  { key: "clientName", header: "Client Name" },
  { key: "orderNumber", header: "Quotes No" },
  { key: "createdAt", header: "Date & Time" },
  { key: "whatsAppNo", header: "Mobile No" },
  { key: "firmEmails", header: "Email Address" },
];

const tabSpecificColumns = {
  Vision: [
    { key: "numberOfOrders", header: "Design Qty" },
    { key: "totalDiaWt", header: "Diamond Wt" },
    { key: "totalNetWt", header: "Gold Wt" },
  ],
  Catalog: [
    { key: "catNo", header: "Cat No." },
    { key: "catName", header: "Catalog Name" },
    { key: "fileData", header: "File" },

    { key: "numberOfOrders", header: "Design QtY" },
    { key: "totalDiaWt", header: "Diamond Wt" },
    { key: "totalNetWt", header: "Gold Wt" },
  ],
  Select: [
    { key: "numberOfOrders", header: "Design QtY" },
    { key: "totalDiaWt", header: "Diamond Wt" },
    { key: "totalNetWt", header: "Gold Wt" },
    { key: "cartScore", header: "Cart Score" },
    { key: "salesPerson", header: "Sales Person" },
  ],
  "My Binny's": [
    { key: "fileData", header: "File" },
    { key: "numberOfOrders", header: "Design QtY" },
    { key: "totalDiaWt", header: "Diamond Wt" },
    { key: "totalNetWt", header: "Gold Wt" },
  ],
  Scan: [
    { key: "numberOfOrders", header: "Design Qty" },
    { key: "totalDiaWt", header: "Diamond Wt" },
    { key: "totalNetWt", header: "Gold Wt" },
  ],
};

// const getColumnsForTab = (tabKey) => {
//   if (tabKey === "My Binny's") {
//     commonColumns.splice(2, 0, { key: "myBinnysClientUserName", header: "User Name" });
//   }
//   return [...commonColumns, ...tabSpecificColumns[tabKey]];
// };
const getColumnsForTab = (tabKey) => {
  let columns = [...commonColumns];

  if (tabKey === "My Binny's") {
    columns.splice(2, 0, { key: "myBinnysClientUserName", header: "User Name" });
  }

  return [...columns, ...tabSpecificColumns[tabKey]];
};

const tabData = {
  Vision: getColumnsForTab("Vision"),
  Catalog: getColumnsForTab("Catalog"),
  Select: getColumnsForTab("Select"),
  "My Binny's": getColumnsForTab("My Binny's"),
  "Scan": getColumnsForTab("Scan"),
};

const action = [
  { label: "email", icon: <Email /> },
  { label: "whatsapp", icon: <Whatsapp /> },
  { label: "pdf", icon: <Pdf /> },
  { label: "details", icon: <Details />, errorIcon: <ErrorDetails /> },
  {
    label: "unarchive",
    icon: <Unarchive />,
  },
  {
    label: "archive",
    icon: <Archive />,
  },
  {
    label: "sync",
    icon: <Sync />,
    errorIcon: <SyncError />
  },
];

const TableSkeleton = memo(({ columns, rows = 5 }) => (
  <>
    {Array.from({ length: rows })?.map((_, rowIndex) => (
      <StyledTableRow key={`skeleton-${rowIndex}`}>
        {Array.from({ length: columns })?.map((_, cellIndex) => (
          <StyledTableBodyCell key={`skeleton-cell-${cellIndex}`}>
            <Skeleton variant="text" sx={{ fontSize: "1rem" }} animation="wave" width="100%" />
          </StyledTableBodyCell>
        ))}
      </StyledTableRow>
    ))}
  </>
));

const Orders = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tableRef = useRef(null);
  let preState = location.state;
  const { search, setSearchBar, searchBar } = useSettingContext();
  const { setSearchPlaceHolder, searchPlaceHolder } = useGlobalContext();
  const [displayDateRange, setDisplayDateRange] = useState("");
  const [loader, setLoader] = useState(false);

  const { mutateAsync: syncOrder } = useSyncOrdertoGati();

  const userData = JSON.parse(localStorage.getItem("userData")) || {};

  const permissions = usePermissions();

  const hasArchiveAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes"), "archive");

  // console.log("hasArchiveAccess===>>",hasArchiveAccess)

  const hasShareAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes"), "share");

  const hasDownloadAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes"), "download");

  const [activeTab, setActiveTab] = useState("Vision");
  const [openDetailModal, setOpenDetailModal] = useState({ open: false, data: {} });
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [finalStartDate, setFinalStartDate] = useState(new Date());
  const [finalEndDate, setFinalEndDate] = useState(null);
  const [isActionOpen, setIsActionOpen] = useState({ open: false, selectAction: "" });
  const [actionData, setActionData] = useState({});
  const [unarchiveOpen, setUnarchiveOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [modalType, setModalType] = useState("");
  const [openFileModal, setOpenFileModal] = useState(false);
  const [fileModalData, setFileModalData] = useState([]);
  const [selectedOrderNum, setSelectedOrderNum] = useState(null);

  const activeTabQuery = {
    Vision: "VISION",
    Catalog: "Design Web",
    Select: "Select",
    "My Binny's": "My_Binnys_App",
    "Scan": "SCAN",
  };

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  // generate pdf quotation
  const generatePdf = useCallback(
    async (data) => {
      try {
        setLoader(true);
        if (!data.gatiOrderId) {
          setLoader(false);

          alert("PDF is Not available in Gati !");
          return false;
        }

        const project = activeTab === "Catalog" ? activeTabQuery[activeTab] : "";
        const url = `/api/v3/client/vision_order/download_Invoice/${data?.gatiOrderId}${project ? `?project=${project}` : ""}`;
        const res = await apiClient.get(url);

        if (res?.data?.status !== 200) {
          setLoader(false);
          alert(res?.data?.message || res?.response?.data?.message);
          return;
        } else {
          window.open(res?.data?.data, "_blank");
          setLoader(false);
          return;
        }
      } catch (error) {
        setLoader(false);
        alert(error?.response?.data?.message || error?.message);
      }
    },
    [activeTab]
  );

  const handleIconClick = (label, rowIndex, row) => {
    if (label === "sync" && row?.gatiOrderId !== null) return;
    if (label === "details") {
      setOpenDetailModal({ open: true, data: row });
    } else if (label === "email" || label === "whatsapp") {
      setIsActionOpen({ open: true, selectAction: label });
      setActionData(
        activeTab === "Catalog"
          ? { email: [row?.client?.clientEmail], mobileNo: [row?.client?.clientNumber], gatiOrderId: row?.gatiOrderId, clientName: row?.client?.clientName }
          : 
          // activeTab !== "My Binny's" ? 
            {
              email: row?.firmEmails,
              mobileNo: row?.whatsAppNo,
              gatiOrderId: row?.gatiOrderId,
              clientName: row?.clientName,
              partyNo: row?.partyNo,
              partyCode: row?.partyCode,
              myBinnysClientUserRefs: row?.myBinnysClientUserRefs || null,
            }
            // : { email: [row?.firmEmails], mobileNo: [row?.whatsAppNo] }
      );
    } else if (label === "pdf") {
      generatePdf(row);
    } else if (label === "unarchive" || label === "archive" || label === "sync") {
      setModalType(label);
      setUnarchiveOpen(true);
      setSelectedOrder(row);
    }
  };

  const handleArchiveUnarchiveOrder = async () => {
    const { projectName, orderNumber } = selectedOrder;
    let payload = {
      projectName: activeTab === "Catalog" ? "CATALOG" : projectName,
      orderNumber,
      makeArchive: modalType === "archive" ? true : false,
    };
    let response = await apiClient.post(`${config.baseUrl}/api/v3/client/vision_order/archiveUnarchiveOrder`, payload);
    if (response?.data?.status === 200) {
      setUnarchiveOpen(false);
      refetch();
      toast.success(response?.data?.message, {
        autoClose: 1000,
        hideProgressBar: false,
      });
    } else {
      toast.error("Soemthing went wrong", {
        autoClose: 1000,
        hideProgressBar: false,
      });
    }
  };

  const unarchiveModalBtnInfo = [
    {
      btnName: modalType === "archive" ? "Archive" : "Unarchive",
      bgColor: "#E77B7B",
      click: () => {
        handleArchiveUnarchiveOrder();
      },
    },

    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setUnarchiveOpen(false),
    },
  ];

  const syncBtnInfo = [
    {
      btnName: "No",
      bgColor: "#E77B7B",
      click: () => setUnarchiveOpen(false),
    },
    {
      btnName: "Yes, Sync",
      bgColor: "#50C878",
      click: async () => {
        try {
          setLoader(true);
          const cleanOrderNumber = selectedOrder?.orderNumber?.replace(/#/g, "");

          let payload = {
            orderNumber: cleanOrderNumber,
            projectName: backData[activeTab],
          }

          const res = await syncOrder(payload);

          setLoader(false);
          setUnarchiveOpen(false);
          toast.success(res?.message, {
            autoClose: 2000,
            hideProgressBar: false,
          });
        } catch (error) {
          setUnarchiveOpen(false);
          setLoader(false);
          toast.error(error?.response?.data?.message, {
            autoClose: 2000,
            hideProgressBar: false,
          });
        }
      }
    },
  ];

  const backData = { Vision: "VISION", Select: "SELECT", Catalog: "CATALOG", "My Binny's": "My Binnys App", Scan: "SCAN" };

  const handleClearDate = () => {
    setStartDate(null);
    setEndDate(null);
    setFinalStartDate(null);
    setFinalEndDate(null);
    //setDisplayDateRange("");
    //setIsCalendarOpen(false);
  };

  // Calendar Submit button
  const handleApply = () => {
    let start = "";
    let end = "";

    if (startDate) {
      start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      start = start.toISOString();
    }

    if (endDate) {
      end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      end = end.toISOString();
    }

    setFinalStartDate(start);
    setFinalEndDate(end);
    setIsCalendarOpen(false);

    const formatDate = (date) => {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = d.toLocaleString("default", { month: "short" });
      const year = d.getFullYear().toString().slice(-2);
      return `${day} ${month} ${year}`;
    };

    if (startDate && endDate) {
      setDisplayDateRange(`${formatDate(startDate)} - ${formatDate(endDate)}`);
    } else if (startDate) {
      setDisplayDateRange(`${formatDate(startDate)} - Select Date`);
    } else {
      setDisplayDateRange("");
    }

    refetch();
  };

  let searchBy = "";
  if (search.length > 0) {
    searchBy = /\d/.test(search) ? "orderNumber" : "clientName";
  }

  let isArchivePage = location?.state?.name?.includes("Archives");
  // console.log("isArchivePage===>>",isArchivePage)

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage, isError, error, refetch } = useOrders({
    limit: 20,
    search,
    projectName: backData[activeTab],
    searchBy,
    filterBy: "date",
    finalStartDate,
    finalEndDate,
    isArchive: isArchivePage,
  });

  const totals = data?.pages[0]?.totals;

  const otherData = [
    {
      icon: <ColorDiamond />,
      label: "Diamond Weight",
      value: totals?.allTotalDiamondWt != null ? `${Number(totals.allTotalDiamondWt).toFixed(2)} Ct` : "0 Ct",
    },
    {
      icon: <ColorGold />,
      label: "Gold Weight",
      value: totals?.allTotalGoldWt != null ? `${Number(totals.allTotalGoldWt).toFixed(2)} g` : "0 g",
    },
    {
      icon: <ColorRings />,
      label: "Design Count",
      value: totals?.allTotalDesignsQty ?? 0,
    },
  ];

  const response = useMemo(() => {
    return data?.pages.flatMap((page) => page.orderData) || [];
  }, [data]);
  const tableData = useMemo(() => {
    return {
      Vision: response,
      Catalog: response,
      Select: response,
      "My Binny's": response,
      Scan: response,
    };
  }, [response]);

  const handleScroll = () => {
    const element = tableRef.current;
    if (element) {
      const { scrollTop, scrollHeight, clientHeight } = element;
      if (scrollTop + clientHeight >= scrollHeight - 5 && hasNextPage && !isFetchingNextPage) {
        setTimeout(() => fetchNextPage(), 1000);
      }
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (finalStartDate && data?.pages[0]?.fromDate && data?.pages[0]?.toDate) {
      const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, "0");
        const month = d.toLocaleString("default", { month: "short" });
        const year = d.getFullYear().toString().slice(-2);
        return `${day} ${month} ${year}`;
      };
      setDisplayDateRange(`${formatDate(data.pages[0].fromDate)} - ${formatDate(data.pages[0].toDate)}`);
    } else if (!finalStartDate) {
      setDisplayDateRange("");
    }
  }, [data, finalStartDate]);

  useEffect(() => {
    setSearchBar(true);
    setSearchPlaceHolder("Search by Client name or quote number");

    return () => {
      setSearchBar(false);
      setSearchPlaceHolder("");
    };
  }, []);

  const theme = useTheme();
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));

  const StyledTableContainer = useMemo(
    () =>
      styled(TableContainer)(() => ({
        backgroundColor: "transparent",
        maxHeight: "65.5vh",
        // height: "70vh",
        marginTop: "1.2vw",
        overflowX: "auto",
        position: "relative",
        border: "1px solid #fff",
        background: "#000",
        scrollbarWidth: "none", // Firefox
        "&::-webkit-scrollbar": {
          height: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#888",
          borderRadius: "3px",
        },
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
      })),
    [isExtraLargeScreen]
  );

  const StyledTable = useMemo(
    () =>
      styled(Table)(() => ({
        "& thead": {
          backgroundColor: "#444444",
          position: "sticky",
          top: 0,
          zIndex: 1,
          "& th": {
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "22px",
            color: "#FFFFFF",
            textAlign: "center",
            fontFamily: "Poppins",
            padding: "10px",
            borderBottom: "1px solid #fff",
          },
        },
        "& tbody": {
          "& td": {
            fontSize: ".7vw",
            fontWeight: 400,
            lineHeight: "1vw",
            color: "#FFFFFF",
            textAlign: "center",
            fontFamily: "Poppins",
            borderBottom: "1px solid #fff",
            padding: ".5vw .25vw",
            border: "1px solid #fff",
          },
        },
        "& th": {
          backgroundColor: "#444444",
          height: "50px",
          position: "sticky",
          top: 0,
          zIndex: 1,
        },
      })),
    []
  );

  const handleOpenFile = (fileModalData, orderNum) => {
    setOpenFileModal(true);
    setFileModalData(fileModalData);
    setSelectedOrderNum(orderNum);
  };

  function formatMobileNumber(number) {
    const str = number.toString();
    if (str.startsWith("91") && str.length > 10) {
      return `+91 ${str.slice(2)}`;
    } else if (str.startsWith("+91 ") && str.length > 10) {
      return `+91 ${str.slice(3)}`;
    } else if (str.length <= 10) {
      return `+91 ${str}`;
    }

    return str;
  }

  return (
    <div style={{ padding: "1vw" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {/* tabs */}
        <div style={{ display: "flex", alignItems: "center", gap: "1.2vw", fontFamily: "Poppins", fontSize: "0.8vw", fontWeight: 600 }}>
          {Object.keys(tabSpecificColumns)?.map((tab) => (
            <div key={tab} style={{ borderBottom: activeTab === tab ? "2px solid #fff" : "", cursor: "pointer", userSelect: "none" }} onClick={() => handleTabClick(tab)}>
              {tab}
            </div>
          ))}
        </div>

        {/* other details */}
        <div style={{ display: "flex", alignItems: "center", gap: "0.8vw" }}>
          {loader && (
            <Modal open={loader}>
              <Box
                sx={{
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress color="success" />
              </Box>
            </Modal>
          )}

          {otherData.map((data) => (
            <div
              key={data.label}
              style={{ backgroundColor: "#0D0D0D", display: "flex", alignItems: "center", gap: "0.5vw", justifyContent: "start", borderRadius: "0.25vw", padding: "0.5vw", paddingRight: "1vw" }}
            >
              <span style={{ backgroundColor: "#262626", width: "1.2vw", height: "1.2vw", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>{data.icon}</span>
              <span style={{ fontFamily: "Karla", fontWeight: 500, fontSize: "0.6vw" }}>{data.label}</span>
              <span style={{ fontFamily: "Poppins", fontWeight: 500, fontSize: "0.7vw" }}>{data.value}</span>
            </div>
          ))}

          <IconButton sx={{ m: 0, p: 0 }} onClick={() => setIsCalendarOpen(true)}>
            {displayDateRange ? (
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "20px",
                  letterSpacing: "-0.18px",
                  verticalAlign: "middle",
                  fontVariantNumeric: "lining-nums proportional-nums",
                  width: "170px",
                  height: "20px",
                  opacity: 1,
                  color: "#FFFFFF",
                }}
              >
                {displayDateRange}
              </span>
            ) : null}
            {isCalendarOpen ? <GreenCalendar /> : <Calendar />}
          </IconButton>
        </div>
      </div>

      {data?.pages[0]?.orderData?.length === 0 ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "70vh" }}>
          <Background />
        </div>
      ) : (
        <StyledTableContainer ref={tableRef} onScroll={handleScroll}>
          <StyledTable>
            {/* Table Header */}
            <TableHead>
              <TableRow>
                {tabData[activeTab].map((el) => (
                  <StyledTableHeaderCell key={el.key}>{el.header}</StyledTableHeaderCell>
                ))}
                <StyledTableHeaderCell>Actions</StyledTableHeaderCell>
              </TableRow>
            </TableHead>
            {/* Table Body */}
            <TableBody>
              {isLoading ? (
                <TableSkeleton columns={tabData[activeTab]?.length + 1 || 10} rows={12} />
              ) : (
                <>
                  {activeTab !== "Catalog" &&
                    tableData[activeTab]?.map((row, rowIndex) => (
                      <StyledTableRow key={rowIndex}>
                        {tabData[activeTab].map((col) => {
                          const value = row[col.key];

                          const isMobileOrEmail = (col.key === "whatsAppNo" && row.whatsAppNo?.length > 0) || (col.key === "firmEmails" && row.firmEmails?.length > 0);
                          const isCatNameLong = col.key === "catName" && typeof value === "string" && value.length > 10;

                          return (
                            <StyledTableBodyCell key={col.key}>
                              <Tooltip
                                title={Array.isArray(value) ? value.map((v, i) => <div key={i}>{`${i + 1}. ${String(isMobileOrEmail ? formatMobileNumber(v) : v)}`}</div>) : String(value)}
                                arrow
                                placement="bottom"
                                enterDelay={200}
                                leaveDelay={100}
                                disableHoverListener={!(isMobileOrEmail || isCatNameLong)}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#fff",
                                      color: "#000",
                                      fontSize: "0.65vw",
                                      boxShadow: 2,
                                      padding: "0.5vw",
                                      whiteSpace: "pre-line",
                                    },
                                    arrow: {
                                      sx: {
                                        color: "#fff",
                                      },
                                    },
                                  },
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: isMobileOrEmail && "pointer" }}>
                                  {(value !== undefined && !(Array.isArray(value) && value.length === 0)) || col.key === "srno" ? (
                                    col.key === "srno" ? (
                                      rowIndex + 1
                                    ) : col.key === "catNo" ? (
                                      `${value}`
                                    ) : col.key === "totalDiaWt" ? (
                                      `${Number(value).toFixed(2)} Ct`
                                    ) : col.key === "totalNetWt" ? (
                                      `${Number(value).toFixed(2)} g`
                                    ) : col.key === "createdAt" ? (
                                      formatDateAndTime(value)
                                    ) : col.key === "salesPerson" && Array.isArray(value) && value?.length > 0 ? (
                                      capitalEachLetter(`${value[0]?.firstName} ${value[0]?.lastName}`)
                                    ) : col.key === "whatsAppNo" && Array.isArray(value) && value?.length > 0 ? (
                                      formatMobileNumber(value[0])
                                    ) : col.key === "myBinnysClientUserName" ? (
                                      capitalEachLetter(value)
                                    ) : col.key === "firmEmails" && Array.isArray(value) && value?.length > 0 ? (
                                      value[0]
                                    ) : isCatNameLong ? (
                                      `${value.slice(0, 10)}...`
                                    ) : col.key === "fileData" ? (
                                      <ImageIcon style={{ cursor: "pointer" }} onClick={() => handleOpenFile(value, row?.orderNumber)} />
                                    ) : (
                                      value
                                    )
                                  ) : (
                                    "-"
                                  )}

                                  {(isMobileOrEmail || isCatNameLong) && value && <Eye style={{ marginLeft: "0.4vw", cursor: "pointer" }} />}
                                </div>
                              </Tooltip>
                            </StyledTableBodyCell>
                          );
                        })}
                        <StyledTableBodyCell>
                          <div style={{ display: "flex", alignItems: "center", gap: "0.4vw", width: "100%", justifyContent: "center" }}>
                            {action.map((el) => {
                              if (el.label === "archive" && !hasArchiveAccess) return null;
                              if ((el.label === "email" || el.label === "whatsapp") && !hasShareAccess) return null;
                              if (el.label === "pdf" && !hasDownloadAccess) return null;

                              if (el.label === "archive" && isArchivePage) return null;
                              if (el.label === "unarchive" && !isArchivePage) return null;
                              const isDisabled = el.label === "sync" && row?.gatiOrderId !== null || el.label === "sync" && row?.isRestricateSomeStyleInGati;

                              if (el.label === "sync" && !userData?.role?.isAdmin) return null;
                              return (
                                <div
                                  key={el.label}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "0.25vw",
                                    padding: el.label === "details" ? "0.45vw" : "0.5vw",
                                    border:
                                      el.label === "email" || el.label === "unarchive" || el.label === "archive" || el.label === "sync"
                                        ? "1px solid #fff"
                                        : el.label === "whatsapp"
                                          ? "1px solid #60D669"
                                          : el.label === "pdf"
                                            ? "1px solid #E77B7B"
                                            : el.label === "details" && row.isRestricateSomeStyleInGati
                                              ? "1px solid #FF0000"
                                              : "1px solid #5078C8",
                                    cursor: "pointer",
                                    ...(isDisabled && {
                                      color: "#8B8B8B",
                                      border: "1px solid #8B8B8B",
                                    }),
                                  }}
                                  onClick={() => handleIconClick(el.label, rowIndex, row)}
                                >
                                  {el.label === "details" && row.isRestricateSomeStyleInGati || isDisabled ? el.errorIcon : el.icon}
                                </div>
                              );
                            })}
                          </div>
                        </StyledTableBodyCell>
                      </StyledTableRow>
                    ))}

                  {activeTab === "Catalog" &&
                    tableData["Catalog"]?.map((row, rowIndex) => (
                      <StyledTableRow>
                        <StyledTableBodyCell>{rowIndex + 1}</StyledTableBodyCell>
                        <StyledTableBodyCell>{row?.client?.clientName}</StyledTableBodyCell>
                        <StyledTableBodyCell>{row?.orderNumber}</StyledTableBodyCell>
                        <StyledTableBodyCell>{formatDateAndTime(row?.createdAt)}</StyledTableBodyCell>
                        <StyledTableBodyCell>
                          <Tooltip
                            title={row?.client?.clientNumber}
                            arrow
                            placement="bottom"
                            enterDelay={200}
                            leaveDelay={100}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#fff",
                                  color: "#000",
                                  fontSize: "0.65vw",
                                  boxShadow: 2,
                                  padding: "0.5vw",
                                  whiteSpace: "pre-line",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#fff",
                                },
                              },
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              {row?.client?.clientNumber || "-"}
                              {row?.client?.clientNumber && <Eye style={{ marginLeft: "0.4vw", cursor: "pointer" }} />}
                            </div>
                          </Tooltip>
                        </StyledTableBodyCell>
                        <StyledTableBodyCell>
                          <Tooltip
                            title={row?.client?.clientEmail}
                            arrow
                            placement="bottom"
                            enterDelay={200}
                            leaveDelay={100}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#fff",
                                  color: "#000",
                                  fontSize: "0.65vw",
                                  boxShadow: 2,
                                  padding: "0.5vw",
                                  whiteSpace: "pre-line",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#fff",
                                },
                              },
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              {row?.client?.clientEmail || "-"}
                              {row?.client?.clientEmail && <Eye style={{ marginLeft: "0.4vw", cursor: "pointer" }} />}
                            </div>
                          </Tooltip>
                        </StyledTableBodyCell>

                        <StyledTableBodyCell>{row?.catalog?.catalogNumber}</StyledTableBodyCell>
                        <StyledTableBodyCell>
                          <Tooltip
                            title={row?.catalog?.catalogName}
                            arrow
                            placement="bottom"
                            enterDelay={200}
                            leaveDelay={100}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#fff",
                                  color: "#000",
                                  fontSize: "0.65vw",
                                  boxShadow: 2,
                                  padding: "0.5vw",
                                  whiteSpace: "pre-line",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#fff",
                                },
                              },
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              {row?.catalog?.catalogName?.length > 10 ? `${row.catalog.catalogName.slice(0, 10)}...` : row.catalog.catalogName || "-"}
                              {row?.catalog?.catalogName?.length > 10 && <Eye style={{ marginLeft: "0.4vw", cursor: "pointer" }} />}
                            </div>
                          </Tooltip>
                        </StyledTableBodyCell>
                        {row?.fileData?.length > 0 ? (
                          <StyledTableBodyCell>
                            <IconButton disableRipple>
                              <ImageIcon style={{ cursor: "pointer" }} onClick={() => handleOpenFile(row?.fileData, row.orderNumber)} />
                            </IconButton>
                          </StyledTableBodyCell>
                        ) : (
                          <StyledTableBodyCell>-</StyledTableBodyCell>
                        )}
                        <StyledTableBodyCell>{row?.numberOfOrders}</StyledTableBodyCell>
                        <StyledTableBodyCell>{Number(row?.totalDiaWt).toFixed(2)} Ct</StyledTableBodyCell>
                        <StyledTableBodyCell>{Number(row?.totalNetWt).toFixed(2)} g</StyledTableBodyCell>
                        <StyledTableBodyCell>
                          <div style={{ display: "flex", alignItems: "center", gap: "0.4vw", width: "100%", justifyContent: "center" }}>
                            {action.map((el) => {
                              if (el.label === "archive" && isArchivePage) return null;
                              if (el.label === "unarchive" && !isArchivePage) return null;
                              const isDisabled = el.label === "sync" && row?.gatiOrderId !== null || el.label === "sync" && row?.isRestricateSomeStyleInGati;

                              if (el.label === "sync" && !userData?.role?.isAdmin) return null;
                              return (
                                <div
                                  key={el.label}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "0.25vw",
                                    padding: el.label === "details" ? "0.45vw" : "0.5vw",
                                    border:
                                      el.label === "email" || el.label === "unarchive" || el.label === "archive" || el.label === "sync"
                                        ? "1px solid #fff"
                                        : el.label === "whatsapp"
                                          ? "1px solid #60D669"
                                          : el.label === "pdf"
                                            ? "1px solid #E77B7B"
                                            : "1px solid #5078C8",
                                    cursor: "pointer",
                                    ...(isDisabled && {
                                      color: "#8B8B8B",
                                      border: "1px solid #8B8B8B",
                                    }),
                                  }}
                                  onClick={() => handleIconClick(el.label, rowIndex, row)}
                                >
                                  {isDisabled ? el.errorIcon : el.icon}
                                </div>
                              );
                            })}
                          </div>
                        </StyledTableBodyCell>
                      </StyledTableRow>
                    ))}
                </>
              )}
            </TableBody>
            {isFetchingNextPage && <TableSkeleton columns={tabData[activeTab]?.length + 1 || 10} rows={3} />}
          </StyledTable>
        </StyledTableContainer>
      )
      }

      <DetailModal open={openDetailModal.open} handleClose={() => setOpenDetailModal({ open: false, data: {} })} data={openDetailModal.data} />

      <DatePickerComp
        startDate={startDate}
        endDate={endDate}
        open={isCalendarOpen}
        handleClear={handleClearDate}
        handleApply={handleApply}
        onChange={onChange}
        handleClose={() => setIsCalendarOpen(false)}
        allowSundays={true}
      />

      <ActionModal
        openModal={isActionOpen.open}
        handleClose={() => setIsActionOpen({ open: false, selectAction: "" })}
        selectAction={isActionOpen.selectAction}
        data={{ ...actionData, activeTab }}
        setLoader={setLoader}
        refetch={refetch}
      />

      <RemoveModal
        open={unarchiveOpen}
        setOpen={setUnarchiveOpen}
        btnInfo={modalType === "sync" ? syncBtnInfo : unarchiveModalBtnInfo}
        oneLiner={modalType !== "sync"}
        cumWidth="488px"
        heading={
          modalType === "sync" ?
            <>
              Are you sure you want to sync with gati?
            </>
            :
            <>
              Are you sure you want to {modalType} <span style={{ fontWeight: "600" }}>{selectedOrder?.orderNumber}</span> quote?
            </>
        }
      />

      {openFileModal && <OrdersFileModal openModal={openFileModal} handleClose={() => setOpenFileModal(false)} data={fileModalData} orderNum={selectedOrderNum} />}
    </div >
  );
};

export default Orders;
